import { render, staticRenderFns } from "./sendScreening.vue?vue&type=template&id=4a23cbe3&scoped=true&"
import script from "./sendScreening.vue?vue&type=script&lang=js&"
export * from "./sendScreening.vue?vue&type=script&lang=js&"
import style0 from "./sendScreening.vue?vue&type=style&index=0&id=4a23cbe3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a23cbe3",
  null
  
)

export default component.exports